import React from 'react';
import ProfilePic from '../img/tarun.jpg'
import ProjectList from '../components/ProjectList';
import projectData from '../data/projects.json';
import linkData from '../data/links.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGithub, 
  faLinkedinIn, 
  faDev,
  faKaggle
} from '@fortawesome/free-brands-svg-icons';

const Home = () => {
  document.title = "Tarun | Home";

  let featuredProjects = {};
  for (const key in projectData) {
    if (projectData[key]['featured']) {
      featuredProjects[key] = projectData[key];
    }
  }

  const iconMapping = {
    'kaggle': faKaggle,
    'github': faGithub,
    'linkedin': faLinkedinIn,
    'devpost': faDev
  }

  const links = Object.keys(linkData).map(key => (
    <a 
      href={linkData[key]['link']} 
      alt={linkData[key]['title']} 
      key={linkData[key]['title']}
      title={linkData[key]['title']}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon 
        icon={iconMapping[key]} 
        className="icon"
      />
    </a>
  ))

  return (
    <div className="content">
      <div className="section span-2">
        <div className="subsection">
          <div className="title">Bio</div>
          <div className="text">Hey there, I'm Tarun, a coder with an interest in scalable technology and cutting-edge system design.</div>
          <div className="text">Currently, I'm a SWE working on technical infrastructure at <a className="list-link" href="https://instabase.com/" target="_blank" rel="noopener noreferrer">Instabase</a>. Previously, I was at <a className="list-link" href="https://azure.com/" target="_blank" rel="noopener noreferrer">Microsoft Azure</a>, working for the Azure Resource Manager Deployments team to develop the infrastructure-as-code experience at Azure. Before that, I was a SWE intern at <a className="list-link" href="https://plaid.com/blog/welcome-summer-2020-plinterns/" target="_blank" rel="noopener noreferrer">Plaid</a> where I developed a low latency HTTP(S/2) request library to serve bank integrations.</div>
          <div className="text">I also conducted undergraduate research at <a className="list-link" href="https://www.cs.utah.edu/docs/techreports/2020/pdf/UUCS-20-011.pdf" target="_blank" rel="noopener noreferrer">Utah NLP lab</a> under Professor <a className="list-link" href="https://svivek.com" target="_blank" rel="noopener noreferrer">Vivek Srikumar</a>. My undergraduate thesis was on <a className="list-link" href="https://www.cs.utah.edu/docs/techreports/2020/pdf/UUCS-20-011.pdf" target="_blank" rel="noopener noreferrer">Transformer-Based Observers in Psychotherapy.</a> </div>
          <div className="text">Want to collaborate on a project? <a className="list-link" href="mailto:tarun.sunkaraneni@gmail.com">Let's chat.</a></div>
        </div>
        <div className="subsection">
          <div className="title">Social</div>
          <div className="social-icon-container">
            {links}
          </div>
        </div>
      </div>
      <div className="section span-1">
        <div className="subsection">
          <div className="title">What I Do</div>
          <div className="list-item">Backend Development</div>
          <div className="list-item">Cloud Infrastructure</div>
          <div className="list-item">Natural Language Processing</div>
        </div>
        <div className="subsection">
          <div className="title">Books I've Recently Read</div>
          <div className="list-item">Klara and the Sun</div>
          <div className="list-item">Sapiens</div>
          <div className="list-item">The Lost Symbol</div>
        </div>
        <div className="subsection">
          <div className="title">Things I'm Learning</div>
          <div className="list-item">Graph Neural Networks</div>
          <div className="list-item">Rust</div>
          <div className="list-item">Rock Climbing</div>
        </div>
      </div>
      <div className="section span-1">
        <div className="subsection">
          <div className="title">Photo</div>
          <img src={ProfilePic} alt="Tarun Sunkaraneni"/>
        </div>
      </div>
      <div className="section featured-projects">
        <div className="subsection">
          <div className="title">Featured Projects</div>
          <ProjectList projects={featuredProjects}/>
        </div>
      </div>
    </div>
  );
}

export default Home;
